/**
 * @generated SignedSource<<e5feb12c844ef68c23e8f76828dfa10a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifyEmailCodeInput = {
  code: string;
  email: string;
};
export type useVerifyEmailCodeMutation$variables = {
  input: VerifyEmailCodeInput;
};
export type useVerifyEmailCodeMutation$data = {
  readonly responsePayload: {
    readonly assignmentToken: string | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly session: {
      readonly currentClientProfile: {
        readonly active?: boolean;
        readonly id?: string;
        readonly member: {
          readonly __typename: "AnonymousCustomer";
        } | {
          readonly __typename: "Customer";
          readonly departmentMemberProfiles: ReadonlyArray<{
            readonly department?: {
              readonly slug: string;
            } | null | undefined;
            readonly ghinNumber?: number | null | undefined;
          } | null | undefined> | null | undefined;
          readonly email: string | null | undefined;
          readonly firstName: string | null | undefined;
          readonly fullName: string;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly membershipType: {
            readonly id: string;
          } | null | undefined;
          readonly phoneNumber: {
            readonly nationalNumber: string;
          } | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | {
          readonly __typename: "Member";
          readonly departmentMemberProfiles: ReadonlyArray<{
            readonly department?: {
              readonly slug: string;
            } | null | undefined;
            readonly ghinNumber?: number | null | undefined;
          } | null | undefined> | null | undefined;
          readonly email: string | null | undefined;
          readonly firstName: string | null | undefined;
          readonly fullName: string;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly memberGroups: ReadonlyArray<{
            readonly id: string;
          } | null | undefined> | null | undefined;
          readonly membershipType: {
            readonly id: string;
          } | null | undefined;
          readonly phoneNumber: {
            readonly nationalNumber: string;
          } | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      } | null | undefined;
      readonly masquerader: {
        readonly email: string | null | undefined;
        readonly username: string | null | undefined;
      } | null | undefined;
      readonly user: {
        readonly __typename: string;
        readonly email: string | null | undefined;
        readonly id: string;
        readonly memberProfiles?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly member: {
                readonly club: {
                  readonly id: string;
                  readonly logoImage: {
                    readonly publicId: string;
                  } | null | undefined;
                  readonly name: string;
                  readonly slug: string;
                };
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly metadata?: {
          readonly hasSeenNotificationNudgeModal: boolean | null | undefined;
        } | null | undefined;
        readonly username: string | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"useSyncAnalyticsTrackingPermission_session">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useVerifyEmailCodeMutation = {
  response: useVerifyEmailCodeMutation$data;
  variables: useVerifyEmailCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignmentToken",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUnauthenticatedAnalyticsTracking",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresAnalyticsTrackingConsent",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsTrackingConsentedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultCountryCode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    }
  ],
  "type": "MemberProfile",
  "abstractKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "GOLF"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ghinNumber",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": (v14/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v15/*: any*/)
          ],
          "storageKey": null
        },
        (v16/*: any*/)
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    }
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
},
v18 = [
  (v12/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "CustomerType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v24/*: any*/)
  ],
  "storageKey": null
},
v26 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "MembershipType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroup",
  "kind": "LinkedField",
  "name": "memberGroups",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v31 = [
  {
    "kind": "Literal",
    "name": "active",
    "value": true
  }
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": (v26/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSeenNotificationNudgeModal",
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v35 = {
  "alias": null,
  "args": (v14/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            (v12/*: any*/)
          ],
          "storageKey": null
        },
        (v16/*: any*/)
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVerifyEmailCodeMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyEmailCodePayload",
        "kind": "LinkedField",
        "name": "verifyEmailCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "useSyncAnalyticsTrackingPermission_session",
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MemberUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "currentClientProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "member",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Club",
                            "kind": "LinkedField",
                            "name": "club",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentClientProfile",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "type": "AnonymousCustomer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v28/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "masquerader",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v12/*: any*/),
                  (v23/*: any*/),
                  (v30/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v31/*: any*/),
                        "concreteType": "MemberProfileConnection",
                        "kind": "LinkedField",
                        "name": "memberProfiles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfileEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberProfile",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberProfiles(active:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MemberUser",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useVerifyEmailCodeMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyEmailCodePayload",
        "kind": "LinkedField",
        "name": "verifyEmailCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v31/*: any*/),
                        "concreteType": "MemberProfileConnection",
                        "kind": "LinkedField",
                        "name": "memberProfiles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfileEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberProfile",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v32/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberProfiles(active:true)"
                      }
                    ],
                    "type": "MemberUser",
                    "abstractKey": null
                  },
                  (v12/*: any*/),
                  (v23/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentClientProfile",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isClient"
                      },
                      (v34/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v35/*: any*/),
                          (v19/*: any*/),
                          (v12/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v36/*: any*/),
                          (v27/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v35/*: any*/),
                          (v28/*: any*/),
                          (v12/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v36/*: any*/),
                          (v27/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "masquerader",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v23/*: any*/),
                  (v30/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "70630818e945d401b1480d52f3cfd2b8",
    "id": null,
    "metadata": {},
    "name": "useVerifyEmailCodeMutation",
    "operationKind": "mutation",
    "text": "mutation useVerifyEmailCodeMutation(\n  $input: VerifyEmailCodeInput!\n) {\n  responsePayload: verifyEmailCode(input: $input) {\n    success\n    assignmentToken\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    session {\n      ...useSyncAnalyticsTrackingPermission_session\n      currentClientProfile {\n        __typename\n        ... on MemberProfile {\n          id\n          active\n        }\n        member {\n          __typename\n          __isClient: __typename\n          ... on AnonymousCustomer {\n            __typename\n          }\n          ... on Customer {\n            departmentMemberProfiles(type: GOLF) {\n              __typename\n              ... on GolfMemberProfile {\n                department {\n                  slug\n                  id\n                }\n                ghinNumber\n              }\n              id\n            }\n            membershipType {\n              id\n            }\n            __typename\n            id\n            firstName\n            lastName\n            fullName\n            email\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            profileImage {\n              publicId: renderingKey\n            }\n          }\n          ... on Member {\n            departmentMemberProfiles(type: GOLF) {\n              __typename\n              ... on GolfMemberProfile {\n                department {\n                  slug\n                  id\n                }\n                ghinNumber\n              }\n              id\n            }\n            membershipType {\n              id\n            }\n            __typename\n            id\n            firstName\n            lastName\n            fullName\n            email\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            profileImage {\n              publicId: renderingKey\n            }\n            memberGroups {\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      masquerader {\n        __typename\n        email\n        username\n        id\n      }\n      user {\n        __typename\n        id\n        email\n        username\n        ... on MemberUser {\n          memberProfiles(active: true) {\n            edges {\n              node {\n                member {\n                  __typename\n                  club {\n                    id\n                    name\n                    slug\n                    logoImage {\n                      publicId: renderingKey\n                    }\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n          metadata {\n            hasSeenNotificationNudgeModal\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useSyncAnalyticsTrackingPermission_session on Session {\n  allowUnauthenticatedAnalyticsTracking\n  requiresAnalyticsTrackingConsent\n  user {\n    __typename\n    ... on MemberUser {\n      metadata {\n        analyticsTrackingConsentedAt\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        defaultCountryCode\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e3c138c35710c3712ae03e316e5f35e";

export default node;
